// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".evet_table_box[data-v-ba4c6bd6]{width:100%;max-height:480px;overflow:auto}.evet_table[data-v-ba4c6bd6]{min-width:100%;border-collapse:collapse}.evet_table td[data-v-ba4c6bd6],.evet_table th[data-v-ba4c6bd6]{height:32px;line-height:32px;min-width:80px}", ""]);
// Exports
module.exports = exports;
